"use strict";

const Util = {
  toType (obj) {
    return {}.toString
      .call(obj)
      .match(/\s([a-zA-Z]+)/)[1]
      .toLowerCase();
  },
  formatDate (date) {
    date = new Date(date);

    if (this.isValidDate(date)) {
      let day = date.getUTCDate();
      let month = date.getUTCMonth() + 1;
      return [
        (day < 10 ? "0" : "") + day,
        (month < 10 ? "0" : "") + month,
        date.getUTCFullYear()
      ].join("/");
    } else if (typeof date === "string" && date.search("/") >= 1) {
      var arrdate = date.split("/");
      // eslint-disable-next-line no-eval
      date = new Date(eval(arrdate[2]), eval(arrdate[1]) - 1, eval(arrdate[0]));
      this.formatDate(date);
    }

    return date;
  },
  isValidDate (d) {
    return d instanceof Date && !isNaN(d);
  },
  stringToDate (strdate) {
    let date;
    if (strdate instanceof Date && !isNaN(strdate)) {
      date = strdate;
    } else if (typeof strdate === 'string' && strdate.search('/') >= 1) {
      const arrdate = strdate.split('/');
      date = new Date(parseInt(arrdate[2], 10), parseInt(arrdate[1], 10) - 1, parseInt(arrdate[0], 10));
    } else {
      date = new Date();
    }
    return date;
  }
};

export default {
  install: Vue => {
    Vue.prototype.$util = Util;
  }
};



// WEBPACK FOOTER //
// ./src/lib/util.js